import { useDispatch } from 'react-redux';
import { useHistory } from 'react-router';
import { Location } from 'history';
import { getPoaApproverList, updatePOAApprover } from '../../redux-store/actions/userManagement';
import { AddPoaApproverRequestBody, poaApprover } from '../../redux-store/types/api-types';
import { ColumnType } from '../DataTable';
import UserMgmtListPage, {
  NameLinkCell,
  buildAccessColumn,
  buildActionsColumn,
  formatPhone,
  formatUserName,
  matchesUserSearch,
} from './UserMgmtListPage';

export default function PoaApprovers({
  location,
}: {
  location: Location<{ distributorId: number }>;
}): JSX.Element {
  const dispatch = useDispatch();
  const history = useHistory();
  const { distributorId } = location.state || {};

  return (
    <UserMgmtListPage<poaApprover>
      loadDeps={[distributorId]}
      loadData={async () => {
        if (!distributorId) {
          history.replace('/user-management');
          return [];
        }
        return (await dispatch(
          getPoaApproverList({ distributorId })
        )) as unknown as poaApprover[];
      }}
      searchPlaceholder="Search for POA Approvers"
      inviteLabel="Add POA Approvers"
      onInvite={() =>
        history.push('add-poaApprover', { distributorId: distributorId.toString() })
      }
      filterRow={(row, q) =>
        matchesUserSearch(q, [
          formatUserName(row.user),
          row.user?.email,
          `${row.user?.countryCode || ''}${row.user?.phone || ''}`,
        ])
      }
      getColumns={({ onToggleAccess }) => {
        const columns: ColumnType[] = [
          {
            header: 'Name',
            align: 'left',
            headerAlign: 'left',
            renderCell: (row: poaApprover) => (
              <NameLinkCell
                label={formatUserName(row.user)}
                to={{ pathname: 'poa-approver-details', state: { poaApproverId: row.id } }}
              />
            ),
          },
          {
            header: 'Mobile Number',
            align: 'left',
            headerAlign: 'left',
            valueGetter: (row: poaApprover) => formatPhone(row.user),
          },
          {
            header: 'Email Id',
            align: 'left',
            headerAlign: 'left',
            valueGetter: (row: poaApprover) => row.user?.email || 'N/A',
          },
          buildAccessColumn(onToggleAccess),
          buildActionsColumn((row: poaApprover) => [
            {
              label: 'View Details',
              icon: '/images/view-application.svg',
              to: { pathname: 'poa-approver-details', state: { poaApproverId: row.id } },
            },
            {
              label: 'Edit Details',
              icon: '/images/edit.svg',
              to: { pathname: 'edit-poaApprover', state: { poaApproverId: row.id } },
            },
          ]),
        ];
        return columns;
      }}
      onAccessChange={async (row, nextActive) =>
        (await dispatch(
          updatePOAApprover(row.id as number, {
            ...(row as unknown as AddPoaApproverRequestBody),
            isActive: nextActive,
          })
        )) as unknown as poaApprover
      }
    />
  );
}
